var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7979 21.0002L18.2494 16.6572M18.2494 16.6572C19.0275 15.9143 19.6446 15.0324 20.0657 14.0618C20.4868 13.0911 20.7035 12.0508 20.7035 11.0002C20.7035 9.9496 20.4868 8.90929 20.0657 7.93866C19.6446 6.96803 19.0275 6.08609 18.2494 5.34321C17.4714 4.60032 16.5478 4.01103 15.5312 3.60898C14.5147 3.20693 13.4252 3 12.3249 3C11.2246 3 10.1351 3.20693 9.11853 3.60898C8.10199 4.01103 7.17835 4.60032 6.40032 5.34321C4.82903 6.84354 3.94629 8.87842 3.94629 11.0002C3.94629 13.122 4.82903 15.1569 6.40032 16.6572C7.97161 18.1575 10.1027 19.0004 12.3249 19.0004C14.547 19.0004 16.6781 18.1575 18.2494 16.6572Z",
    stroke: "#8E929A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/SearchIcon.c46ac1ebc70d7134286508d0c714172e.svg";
export { ForwardRef as ReactComponent };